import React, { useEffect, useMemo } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import TimeoutModal from "./TimeoutModal/TimeoutModal";

const STORAGE_KEY = "timeoutSessionMessage";
const IDLE_TIMEOUT = 1000 * 60 * 30; // 30 minutes
let countdownInterval;
let timeout;

const sendMessage = (message) => {  
  localStorage.setItem(STORAGE_KEY, JSON.stringify(message));
  localStorage.removeItem(STORAGE_KEY); // Clean up to trigger the storage event
};

const SessionTimeout = () => {
  const [timeoutModalOpen, setTimeoutModalOpen] = useState(false);
  const [timeoutCountdown, setTimeoutCountdown] = useState(0);
  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: onIdle,
    onActive: () => {
      onActive();
    },
    onAction: () => {
      onActive();
    },
    debounce: 5000,   
  });

  function storageEventListener(event) {
    if (event.key === STORAGE_KEY) {
      const message = JSON.parse(event.newValue);
      if (!message?.type) {
        return;
      }
      if (message.type === "logout") {
        handleLogout(true);
      }
      if (message.type === "continue") {
        handleContinue(true);
      }
      if (message.type === "active") {
        onActive(true);
      }
    }
  }

  useEffect(() => {
    window.addEventListener("storage", storageEventListener);
    return () => {
      window.removeEventListener("storage", storageEventListener);
    };
  }, []);

  const clearSessionTimeout = () => {
    clearTimeout(timeout);
  };

  const clearSessionInterval = () => {
    clearInterval(countdownInterval);
  };

  const logOut = () => {
    localStorage.clear();
    window.location.reload(true);
  };

  const handleLogout = async (isFromOtherTab = false) => {
    try {
      if (!isFromOtherTab) {
        sendMessage({ type: "logout" });
      }
      setTimeoutModalOpen(false);
      clearSessionInterval();
      clearSessionTimeout();
      logOut();
    } catch (err) {
      console.error(err);
    }
  };

  const handleContinue = (isFromOtherTab = false) => {
    setTimeoutModalOpen(false);
    clearSessionInterval();
    clearSessionTimeout();
    if (!isFromOtherTab) {
      sendMessage({ type: "continue" });
    }   
  };

  function onActive(isFromOtherTab = false) {
    if (!timeoutModalOpen) {
      if (!isFromOtherTab) {
        sendMessage({ type: "active" });
      }
      clearSessionInterval();
      clearSessionTimeout();
    }
  }

  function onIdle() {
    const delay = 1000 * 1;
    if (!timeoutModalOpen) {
      timeout = setTimeout(() => {
        let countDown = 45;
        setTimeoutModalOpen(true);
        setTimeoutCountdown(countDown);
        countdownInterval = setInterval(() => {
          if (countDown > 0) {
            setTimeoutCountdown(--countDown);
          } else {
            handleLogout(true);
          }
        }, 1000);
      }, delay);
    }
  }

  return (
    <>
      <TimeoutModal
        countdown={timeoutCountdown}
        onContinue={() => {handleContinue()}}
        open={timeoutModalOpen}
        onCloseSession={() => {handleLogout()}}
      />
    </>
  );
};

export default SessionTimeout;
